import { Component, type ErrorInfo, type ReactNode } from 'react';
import { logFrontendError } from '../lib/errorLog.js';

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    logFrontendError('react-boundary', { componentStack: info.componentStack }, error);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--surface)] p-6">
          <div className="max-w-md text-center space-y-3">
            <h1 className="text-lg font-semibold text-[var(--t1)]">Algo deu errado</h1>
            <p className="text-sm text-[var(--t3)]">
              Ocorreu um erro inesperado nesta tela. Você pode tentar recarregar a página.
            </p>
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => window.location.reload()}
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
